"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactComponents = require("@ui-propulsion/react-components");
var useStyles = (0, _reactComponents.makeStylesPropulsion)(function (theme) {
  var palette = theme.palette,
    typography = theme.typography;
  var fontFamilyRegular = typography.fontFamilyRegular,
    pxToRem = typography.pxToRem;
  return {
    root: {
      fontFamily: fontFamilyRegular,
      border: "1px solid ".concat(palette.denim[50]),
      fontSize: pxToRem(12),
      color: palette.neutral.narwhal,
      '& .pds-accordion': {
        border: 'none',
        color: palette.neutral.narwhal,
        '& .pds-accordion__section': {
          border: 'none',
          backgroundColor: palette.neutral.iceberg
        },
        '& .pds-accordion__section-header': {
          padding: "".concat(pxToRem(16), " ").concat(pxToRem(19.5), " ").concat(pxToRem(18), " ").concat(pxToRem(16))
        },
        '& .Mui-expanded .pds-accordion__section-header': {
          padding: "".concat(pxToRem(16), " ").concat(pxToRem(19.5), " ").concat(pxToRem(12), " ").concat(pxToRem(16))
        },
        '& .pds-accordion__section-header:hover': {
          backgroundColor: 'inherit'
        },
        '& .pds-accordion__expand-icon': {
          color: palette.neutral.narwhal
        },
        '& .pds-accordion__section-body': {
          fontSize: pxToRem(12),
          fontFamily: fontFamilyRegular,
          color: palette.neutral.narwhal,
          padding: '0'
        }
      }
    },
    leadin: {
      fontSize: pxToRem(12),
      fontFamily: fontFamilyRegular,
      color: palette.denim[300],
      lineHeight: pxToRem(16)
    },
    unsupportedList: {
      margin: "0 0 ".concat(pxToRem(12), " 0"),
      padding: "0 ".concat(pxToRem(32.5)),
      '& ::marker': {
        paddingLeft: pxToRem(4)
      }
    },
    disclaimer: {
      lineHeight: "".concat(pxToRem(16)),
      margin: 0,
      padding: "".concat(pxToRem(12), " ").concat(pxToRem(16), " ").concat(pxToRem(16), " ").concat(pxToRem(16))
    }
  };
}, {
  name: 'PlaidUnsupportedAccounts'
});
exports.useStyles = useStyles;
